import { useCallback, useEffect, useState } from 'react';

const OPTIONS = {
  enableHighAccuracy: true,
  timeout: 12000,
  maximumAge: 300000,
};

export default function useCustomerLocation({ requestOnMount = true } = {}) {
  const [coordinates, setCoordinates] = useState(null);
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  const requestLocation = useCallback(() => {
    if (!navigator.geolocation) {
      setStatus('unsupported');
      setError('Location is not supported by this browser.');
      return;
    }

    setStatus('loading');
    setError('');

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        setCoordinates({
          latitude: coords.latitude,
          longitude: coords.longitude,
        });
        setStatus('success');
      },
      (locationError) => {
        setStatus('error');
        setError(
          locationError.code === locationError.PERMISSION_DENIED
            ? 'Allow location access to see the restaurants closest to you.'
            : 'We could not determine your location. You can still browse every restaurant.'
        );
      },
      OPTIONS
    );
  }, []);

  useEffect(() => {
    if (requestOnMount) requestLocation();
  }, [requestLocation, requestOnMount]);

  return { coordinates, status, error, requestLocation };
}
